const phone = '+225 20 00 61 61'
const email = 'jforce@jumia.ci'
const supportedLanguages = ['fr']
const personalInfo = {
  phoneNumberMask: '## ## ######'
}
const paymentMethods = {
  bankAccountMask: '### ### ####'
}

export {
  // auxiliary objects
  phone,
  email,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
